export function buildStrategyByWorkspaceIdQueryV1(workspaceId: number)
{
	return {
		'$type': 'TCh.Domain.Quest.Strategies.Queries.StrategyByWorkspaceIdQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
	}
}

export function buildStrategySettingsQueryV1(workspaceId: number, strategyId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Strategies.Queries.StrategySettingsQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId
	}
}

export function buildStrategyFixPageQueryV1(workspaceId: number, strategyId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Strategies.Queries.StrategyFixPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId
	}
}


export function buildProjectPlanTemplatesPageQueryV1(workspaceId: number, strategyId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Strategies.Queries.ProjectPlanTemplatesPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
	}
}



export function buildAllProjectsPageQueryV1(workspaceId: number, strategyId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Strategies.Queries.AllProjectsPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
	}
}

export function buildProposedProjectsPageQueryV1(workspaceId: number, strategyId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Strategies.Queries.ProposedProjectsPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
	}
}

export function buildScheduledProjectsPageQueryV1(workspaceId: number, strategyId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Strategies.Queries.ScheduledProjectsPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
	}
}

export function buildStartedProjectsPageQueryV1(workspaceId: number, strategyId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Strategies.Queries.StartedProjectsPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
	}
}

export function buildFinishedProjectsPageQueryV1(workspaceId: number, strategyId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Strategies.Queries.FinishedProjectsPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
	}
}
